import { filter } from 'lodash';
import { __ } from '@wordpress/i18n';
import {
	BlockControls,
	__experimentalBlockAlignmentMatrixToolbar as BlockAlignmentMatrixToolbar,
  __experimentalBlockAlignmentMatrixControl as BlockAlignmentMatrixControl,
  MediaUpload,
	MediaUploadCheck,
  BlockIcon,
} from '@wordpress/block-editor';

import {
	DropdownMenu,
	MenuGroup,
	MenuItem,
	ToolbarGroup,
	Button,
	ButtonGroup,
	ToolbarButton,
	ResizableBox,
	PanelBody,
	BaseControl,
  IconBuutton,
	Toolbar,
} from '@wordpress/components';
import {
  Platform,
} from '@wordpress/element';
import MixBlendControl from '../../../components/reusable/mix-blend-control'

const PLACEHOLDER_TEXT = Platform.select( {
	web: __(
		'Drag images, upload new ones or select files from your library.'
	),
	native: __( 'ADD MEDIA' ),
} );
const ALLOWED_MEDIA_TYPES = [ 'image' ];

export default ( props ) => {
  const {
    contentPosition,
    media,
  } = props.attributes;

  const hasMedia = !! media.length;

  const innerSlides = filter( props.innerBlocks, { name: 'eedee/block-gutenslide' } );

  return (
    <>
			<BlockControls>
        { BlockAlignmentMatrixToolbar && <BlockAlignmentMatrixToolbar
            label={ __( 'Change content position' ) }
            value={ contentPosition }
            onChange={ ( nextPosition ) =>
              props.updateContentPosition( nextPosition )
            }
          /> }
          { BlockAlignmentMatrixControl && <BlockAlignmentMatrixControl
            label={ __( 'Change content position' ) }
            value={ contentPosition }
            onChange={ ( nextPosition ) =>
              props.updateContentPosition( nextPosition )
            }
          /> }
      </BlockControls>
      <BlockControls>
        <MediaUploadCheck>
            <MediaUpload
              onSelect={ props.onSelect }
              gallery
              addToGallery={ hasMedia }
              isAppender={ hasMedia }
              allowedTypes={ ALLOWED_MEDIA_TYPES }
              accept="image/*,video/*"
              multiple
              labels={ {
                title: ! hasMedia && __( 'Gutenslider' ),
                instructions: ! hasMedia && PLACEHOLDER_TEXT,
              } }
              value={ innerSlides.map( ( slide ) => {
                return slide.attributes.background.mediaId;
              } ) }
              render={ ( { open } ) => (
								<ToolbarGroup >
									<ToolbarButton
										className="components-toolbar__control"
										label={ __( 'Edit Slides', 'gutenslider' ) }
										icon="images-alt2"
										onClick={ open }
									/>
								</ToolbarGroup>
              ) }
            />
        </MediaUploadCheck>
				{ /* <MixBlendControl { ...props }/> */ }
      </BlockControls>
    </>
  );
};
